import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { APIService } from 'api/module'
import { MessageBoxService } from 'common/util/services/messageBox.service'
import { MediaPermissionsService } from 'media/services/mediaPermissions.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { NotifyService } from 'common/util/services/notify.service'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class UseAsTemplateOp extends BaseOperation {
  icon = 'far fa-border-style-alt'
  showInAdvancedContextMenu = true
  supportsDirs = true
  supportsBundles = true
  weight = 1000

  constructor (
    private translate: TranslateService,
    private mediaPermissions: MediaPermissionsService,
    private api: APIService,
    private messageBox: MessageBoxService,
    private notify: NotifyService,
  ) {
    super()
    this.label = translate.instant('Use as a template')
  }

  isEnabledForDir (dir, _options) {
    return dir.present && this.mediaPermissions.getPermissionForFile(dir)?.allowWriteDb
  }

  isEnabledForBundle (bundle, _options) {
    return bundle?.mainfile?.present && this.mediaPermissions.getPermissionForBundle(bundle)?.allowWriteDb
  }

  async runForDir (dir, _options) {
    await this.useAsTemplate(dir)
  }

  async runForBundle (bundle, _options) {
    await this.useAsTemplate(bundle.mainfile)
  }

  async useAsTemplate (file) {
    const message = await this.messageBox.prompt({ prompt: this.translate.instant('New template name'), value: file.name }).catch(() => null)
    const name = message?.value
    if (!name) {
      return
    }
    await this.api.mediaLibrary.createMediaFileTemplate({
      mediaFileTemplateUpdate: {
        name,
        file,
      },
    })
    this.notify.success(this.translate.instant('Template saved'))
  }
}

MediaOperationsService.register(UseAsTemplateOp)
